import { WSElement, WSElementProps } from "@wingspanhq/fe-component-library";
import React from "react";
import { CreditCardBrandLogo } from ".";
import { CreditCardType } from "../../types/creditCard";
import styles from "./CreditCardBrandLogo.module.scss";

type Props = {
  type: CreditCardType;
} & WSElementProps;

export const CreditCardLogoCircle: React.FC<Props> = ({
  type,
  ...elementProps
}) => {
  return (
    <WSElement className={styles.creditCardLogoCircle} {...elementProps}>
      <CreditCardBrandLogo type={type} />
    </WSElement>
  );
};
